module.exports = __webpack_public_path__ + "static/media/Portal.989c1e0c.png";